import React from 'react'
import Loader from 'react-loaders'
import './Contact.scss'
import emailjs from "@emailjs/browser"
import {useRef} from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

function Contact() {
  const refForm = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zo0undt', 'template_ps9txzi', refForm.current, 'tCrZdTljneKRD8vvB')
      .then((result) => {
          console.log(result.text);
          console.log('Message sent')
          alert('Message Sent Successfully!')
          window.location.reload(false)
      }, (error) => {
          console.log(error.text);
          alert('Failed to send Message, please try again!')
      });
  };

  return (
    <>
         <div className="container about-page ">
        <div className="text-zone flex-1">
          <h1 className='text-[#63e8ff] font-bold text-2xl md:text-2xl'>
           Get In touch
          </h1>
                <div className='contact-form w-full mt-[20px] flex flex-col'>
                  <form ref={refForm} onSubmit={sendEmail}>
                    <ul className='p-0 m-0' >
                      <li className='half'>
                        <input type="text" name="name" placeholder='Name' required />

                      </li>
                      <li className='half'>
                        <input type="email" name="email" placeholder='Email' required />

                      </li>
                      <li>
                        <input type="text" name="subject" placeholder='Subject' required />

                      </li>
                      <li >
                        <input className='textarea' type="textarea" name="message" placeholder='Message' required />

                      </li>
                      <li>
                        <input className="form-button shadow-lg shadow-teal-400 rounded-lg" type="submit" value="Send Message" />
                       

                      </li>
                    </ul>
                  </form>
                  {/* <div class="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="dark" data-type="VERTICAL" data-vanity="prarthnaluthra" data-version="v1"><a class="badge-base__link LI-simple-link" href="https://in.linkedin.com/in/prarthnaluthra?trk=profile-badge">Prarthna Luthra</a></div> */}
              

                </div>
                

            </div>
            <div className='info-map'>
                  Prarthna Luthra
                  <br/>
                  India
                  <br/>
                  New Delhi, Delhi
                  <span>prarthnaluthra@gmail.com</span>


                </div>
                <div className='map-wrap'>
                  <MapContainer center={[28.660580,77.137283]} zoom={13}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[28.660580, 77.137283]}>
              <Popup>Prarthna's location :)</Popup>
            </Marker>
                  </MapContainer>
                  

                </div>
      </div>
    <Loader type='ball-scale-multiple'/>
    
    </>
  )
}

export default Contact